import React, { Component } from 'react';
import { Link, Route, Redirect } from 'react-router-dom';
import App from '../app';
import './index.scss';

function getCookie(c_name) {
    if (document.cookie.length > 0) {
        let c_start = document.cookie.indexOf(c_name + "=")
        if (c_start != -1) {
            c_start = c_start + c_name.length + 1
            let c_end = document.cookie.indexOf(";", c_start)
            if (c_end == -1) c_end = document.cookie.length
            return unescape(document.cookie.substring(c_start, c_end))
        }
    }
    return ""
}

class index extends Component {
    componentWillMount() {
        let user = getCookie('user');
        if (!user) {
            window.location.href = "/#/login";
        } else {
            sessionStorage.setItem("user", user);

        }
    }

    render() {
        return (
            <Route path="/table" component={App} />
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/admin/index.js